import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import type {
  ActionSchema,
  DashboardMenuPluginConfig,
} from '@wix/cli-app-definitions';
import { getDashboardMenuPluginsDir } from '@wix/cli-app-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_MENU_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/dashboard-menu-plugin'
);

export async function generateDashboardMenuPlugin(
  projectFolder: string,
  extended: string,
  action: ActionSchema,
  folder: string,
  title: string
) {
  const cwd = path.join(getDashboardMenuPluginsDir(projectFolder), folder);
  const menuPluginConfig: DashboardMenuPluginConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/dashboard-menu-plugin.json',
    id: randomUUID(),
    title,
    iconKey: 'Sparkles',
    extends: extended,
    action,
  };
  const menuPluginConfigJSON = toJsonString(menuPluginConfig, { spaces: 2 });

  return await componentGenerator({
    template: DASHBOARD_MENU_PLUGIN_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      menuPluginConfigJSON,
    },
  });
}
